//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    inject: ['EventBus', 'PIXIWrapper'],

    props: {
        path: {
            type: String,
            required: true
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 750
        },
        height: {
            type: Number,
            default: 421.875
        },
        copyright: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            show: false,
            showControls: true
        };
    },

    computed: {
        fullPath () {
            return this.$helper.assetUrl + this.path;
        }
    },

    mounted () {
        this.PIXIWrapper.LoaderManager.add(this, () => {
            this.show = true;
        });
    },

    methods: {
        play () {
            this.$refs.video.play();
            this.showControls = false;
        }
    }
};
